import {InputAdornment, TextField} from '@mui/material';
import {makeStyles} from '@mui/styles';

import styles from 'assets/jss/FormikField.js';
import {digitsEnToFa, digitsFaToEn} from 'persian-tools2';
const useStyles = makeStyles(styles);

const CustomTextField = ({
  name,
  label,
  errors,
  values,
  type,
  icon,
  setFieldValue,
  maxLength,
  disabled,
  submitCount,
  showValueCenter,
  placeholder,
}) => {
  const classes = useStyles();
  const isAddressField = name === 'scanCenterAddress';
  const addressFieldLength =  values?.scanCenterAddress?.length !== 0 && values?.scanCenterAddress;
  // textArea style
  const textArea = {
    '& textArea': {
      textAlign: 'right',
      marginTop: addressFieldLength && '20px',
    },
  };

  // custom textfield style for address
  const textAreaStyle = {
    '& input': {
      direction:
          name === 'name'
              ? 'rtl'
              : name === 'phoneNumber'
                  ? 'ltr'
                  : name === 'scanCenterAddress'
                      ? 'rtl !important'
                      : '',
    },
    '& .MuiInputBase-root': {
      display: isAddressField && 'flex',
      paddingRight: isAddressField && '65px',
      flexDirection: isAddressField && addressFieldLength && 'column',
      height: isAddressField && !addressFieldLength && '48px',
      minHeight: isAddressField && '48px',
    },
    '& .MuiOutlinedInput-root': {
      padding:'13.5px 14px',
      paddingRight: '70px'
    },
  };
  // اسنجا
  const inputWidth =
    type === 'number' ? '100%' : `${values[name]?.length + 1.5}ch`;

  const inputProps = {
    input: {
      '&::placeholder': {
        textOverflow: 'ellipsis !important',
        color: 'blue',
      },
    },
    style: {
      textAlign: showValueCenter ? 'center' : 'left',
      letterSpacing: type === 'number' && '1px',
      width: inputWidth,
      marginRight: 'auto',
    },
    maxLength,
    inputMode: type === 'number' ? 'numeric' : 'text',
  };

  const inlineStyle = {
    '& .MuiOutlinedInput-root': {
      border: errors[name] && !!submitCount && '1px solid var(--red)',
    },
    input: {
      '&::placeholder': {
        opacity: '1',
        fontWeight: 400,
        textAlign: 'center',
        letterSpacing: 'normal',
        color: '#707070',
      },
    },
  };

  const onChangeHandler = (e) => {
    if (e.target.value.length < 12 && type === 'number') {
      setFieldValue(name, digitsFaToEn(e.target.value));
    } else if (type === 'text') {
      setFieldValue(name, e.target.value);
    }
  };

  return (
    <>
      <div className={classes.parentTextField}>
        <div className={classes.textFieldMarker}>
          {label ? `${label} :` : icon}
        </div>
        <TextField
          fullWidth
          type='text'
          placeholder={placeholder}
          disabled={disabled}
          name={name}
          sx={isAddressField?textAreaStyle:inlineStyle}
          multiline={isAddressField}
          inputProps={isAddressField?{
            // className: classes.inputBox,
            sx: textArea,
            maxLength: 71,
            style:{textAlign: 'left'}
          }:inputProps}
          onChange={onChangeHandler}
          className={classes.textfied}
          value={digitsEnToFa(values[name])}
          dir={type === 'text' ? 'rtl' : 'ltr'}
        />
      </div>
      {errors[name] && !!submitCount && (
        <div className={classes.errorText}>{errors[name]}</div>
      )}
    </>
  );
};

export default CustomTextField;
